import React from 'react'
import { Link } from 'react-router-dom'
import {
  Box,
  Container,
  Grid,
  Typography,
  IconButton,
  Divider,

} from '@mui/material'
import {
  Phone,
  Email,
  LocationOn,
  WhatsApp,
  Facebook,

  Instagram,
  LinkedIn
} from '@mui/icons-material'

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear()

  const quickLinks = [
    { label: 'Home', path: '/' },
    { label: 'Products', path: '/products' },
    { label: 'Services', path: '/services' },
    { label: 'About Us', path: '/about' },
    { label: 'Blogs', path: '/blogs' },
    { label: 'Solar Pricing', path: '/solar-pricing' },
  ]

  const customerLinks = [
    { label: 'My Orders', path: '/my-orders' },
    { label: 'Payment Methods', path: '/payment-methods' },
    { label: 'Shipping Info', path: '/shipping' },
    { label: 'Returns', path: '/returns' },
    { label: 'FAQ', path: '/faq' },
    { label: 'Support', path: '/support' },
  ]

  const companyLinks = [
    { label: 'About Starwave Energy', path: '/about' },
    { label: 'Our Team', path: '/team' },
    { label: 'Careers', path: '/careers' },
    { label: 'Press', path: '/press' },
    { label: 'Privacy Policy', path: '/privacy' },
    { label: 'Terms of Service', path: '/terms' },
  ]

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'secondary.main',
        color: 'white',
        mt: 'auto',
        pt: 6,
        pb: 3,
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={4}>
          {/* Company Info */}
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Box
                component="img"
                src="/logo.jpeg"
                alt="Starwave Energy"
                sx={{ height: 40, mr: 1.5, borderRadius: '50%' }}
              />
              <Typography
                variant="h5"
                component="div"
                sx={{ fontWeight: 'bold', color: 'primary.light' }}
              >
                Starwave Energy
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ mb: 3, lineHeight: 1.6 }}>
              Your trusted source for solar products and solutions. We provide
              high-quality solar panels, inverters, and batteries to power your
              future with clean, renewable energy.
            </Typography>

            {/* Contact Info */}
            <Box sx={{ mb: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Phone sx={{ mr: 1, fontSize: 18 }} />
                <Typography variant="body2">0313 9766286</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Email sx={{ mr: 1, fontSize: 18 }} />
                <Typography variant="body2">support@starwaveenergy.live</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                <LocationOn sx={{ mr: 1, fontSize: 18, mt: 0.2 }} />
                <Typography variant="body2">
                  Farah naz shopping complex,<br />
                  opp Hafiz Plaza, Tangi Road,<br />
                  Charsadda
                </Typography>
              </Box>
            </Box>

            {/* Social Media */}
            <Box>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 600 }}>
                Follow Us
              </Typography>
              <Box>
                <IconButton
                  href={`https://wa.me/923300398953`}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ color: 'primary.light', p: 0.5 }}
                >
                  <WhatsApp />
                </IconButton>
                <IconButton
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ color: 'primary.light', p: 0.5 }}
                >
                  <Facebook />
                </IconButton>
                <IconButton
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ color: 'primary.light', p: 0.5 }}
                >
                  <Instagram />
                </IconButton>
                <IconButton
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ color: 'primary.light', p: 0.5 }}
                >
                  <LinkedIn />
                </IconButton>
              </Box>
            </Box>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography
              variant="h6"
              component="div"
              sx={{ fontWeight: 600, mb: 2, color: 'primary.light' }}
            >
              Quick Links
            </Typography>
            <Box>
              {quickLinks.map((link) => (
                <Typography
                  key={link.path}
                  variant="body2"
                  component={Link}
                  to={link.path}
                  sx={{
                    display: 'block',
                    color: 'inherit',
                    textDecoration: 'none',
                    mb: 1,
                    '&:hover': {
                      color: 'primary.light',
                      textDecoration: 'underline',
                    },
                  }}
                >
                  {link.label}
                </Typography>
              ))}
            </Box>
          </Grid>

          {/* Customer Service */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              component="div"
              sx={{ fontWeight: 600, mb: 2, color: 'primary.light' }}
            >
              Customer Service
            </Typography>
            <Box>
              {customerLinks.map((link) => (
                <Typography
                  key={link.path}
                  variant="body2"
                  component={Link}
                  to={link.path}
                  sx={{
                    display: 'block',
                    color: 'inherit',
                    textDecoration: 'none',
                    mb: 1,
                    '&:hover': {
                      color: 'primary.light',
                      textDecoration: 'underline',
                    },
                  }}
                >
                  {link.label}
                </Typography>
              ))}
            </Box>
          </Grid>

          {/* Company */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              component="div"
              sx={{ fontWeight: 600, mb: 2, color: 'primary.light' }}
            >
              Company
            </Typography>
            <Box>
              {companyLinks.map((link) => (
                <Typography
                  key={link.path}
                  variant="body2"
                  component={Link}
                  to={link.path}
                  sx={{
                    display: 'block',
                    color: 'inherit',
                    textDecoration: 'none',
                    mb: 1,
                    '&:hover': {
                      color: 'primary.light',
                      textDecoration: 'underline',
                    },
                  }}
                >
                  {link.label}
                </Typography>
              ))}
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: 'rgba(255, 255, 255, 0.2)' }} />

        {/* Bottom Section */}
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="body2" sx={{ opacity: 0.8 }}>
              © {currentYear} Starwave Energy. All rights reserved.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', justifyContent: { xs: 'flex-start', md: 'flex-end' }, gap: 2 }}>
              <Typography
                variant="body2"
                component={Link}
                to="/privacy"
                sx={{
                  color: 'inherit',
                  textDecoration: 'none',
                  opacity: 0.8,
                  '&:hover': {
                    opacity: 1,
                    textDecoration: 'underline',
                  },
                }}
              >
                Privacy Policy
              </Typography>
              <Typography
                variant="body2"
                component={Link}
                to="/terms"
                sx={{
                  color: 'inherit',
                  textDecoration: 'none',
                  opacity: 0.8,
                  '&:hover': {
                    opacity: 1,
                    textDecoration: 'underline',
                  },
                }}
              >
                Terms of Service
              </Typography>
              <Typography
                variant="body2"
                component={Link}
                to="/cookies"
                sx={{
                  color: 'inherit',
                  textDecoration: 'none',
                  opacity: 0.8,
                  '&:hover': {
                    opacity: 1,
                    textDecoration: 'underline',
                  },
                }}
              >
                Cookie Policy
              </Typography>
            </Box>
          </Grid>
        </Grid>

        {/* Trust Badges */}
        <Box sx={{ mt: 4, textAlign: 'center' }}>
          <Typography variant="body2" sx={{ opacity: 0.6, mb: 2 }}>
            Trusted by thousands of customers across Pakistan
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3, flexWrap: 'wrap' }}>
            <Typography variant="caption" sx={{ opacity: 0.6 }}>
              🔒 Secure Payments
            </Typography>
            <Typography variant="caption" sx={{ opacity: 0.6 }}>
              🚚 Fast Delivery
            </Typography>
            <Typography variant="caption" sx={{ opacity: 0.6 }}>
              ⭐ Quality Products
            </Typography>
            <Typography variant="caption" sx={{ opacity: 0.6 }}>
              📞 24/7 Support
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default Footer